import { memo, useEffect, useMemo } from "react";
import { useSessionStore } from "../store/useSessionStore";
import { RequestStatus, LINK_ERROR_CODE } from "../utils/commons";
import { APP_ROUTES } from "../constants";
import { useStore } from "../store/globalState";
import {
  AuraLayout,
  BodyCopy,
  KapitalIcon,
  Layout,
  Loader,
} from "lola-framework-ui-test";
import { Trans } from "react-i18next";
import { t } from "i18next";
import { useRouteWithToken } from "../hooks/useRouteWithToken";
import { useClaimLink } from "../hooks/useClaimLink";

export const LoadingPage = memo(() => {
  useClaimLink();

  const { redirectTo } = useRouteWithToken();
  const { session } = useSessionStore();
  const { theme } = useStore();
  const colorConfig = theme.whiteView;

  useEffect(() => {
    let timer = undefined;
    if (session.status === RequestStatus.LOADED) {
      const target = session.data?.termsAccepted
        ? APP_ROUTES.TRANSACTIONS_PAGE
        : APP_ROUTES.LANDING_PAGE;
      timer = setTimeout(() => {
        redirectTo(target);
      }, 3000);
    } else if (session.status === RequestStatus.ERROR && session.error) {
      // Check if the error is a session expiration error
      const isSessionExpiredError =
        session.error.errorCode === LINK_ERROR_CODE.LINK_EXPIRED ||
        session.error.errorCode === LINK_ERROR_CODE.LINK_NOT_FOUND;

      if (isSessionExpiredError) {
        timer = setTimeout(() => {
          // Navigate to session expired page for link expired/not found errors
          redirectTo(APP_ROUTES.SESSION_EXPIRED_PAGE);
        }, 3000);
      } else {
        // Pass the error state to ErrorPage via location.state for other errors
        timer = setTimeout(() => {
          redirectTo(APP_ROUTES.ERROR_PAGE);
        }, 3000);
      }
    }
    return () => clearTimeout(timer);
  }, [
    session.status,
    session.error,
    session.data?.termsAccepted,
    redirectTo,
  ]);

  const partnerLogo = useMemo(
    () =>
      session.data?.partner.logoUrl ? (
        session.data.partner.name.toLocaleLowerCase() === "kapital" ? (
          <KapitalIcon size={120} className="animate-spin" />
        ) : (
          <img className="img-logo" src={session.data.partner.logoUrl} />
        )
      ) : (
        <Loader size={32} />
      ),
    [session.data]
  );

  return (
    <AuraLayout colorConfig={colorConfig}>
      <Layout.Header>
        <BodyCopy className="footer-text">
          <label className=" muted-foreground">
            <Trans i18nKey="loader.sponsored" />
          </label>
        </BodyCopy>
      </Layout.Header>
      <Layout.Content>
        <div className="landing-section content-center loader-page">
          <section className="content">{partnerLogo}</section>
        </div>
      </Layout.Content>

      <Layout.Footer>
        <label className=" muted-foreground patriot-text">
          {t("loader.patriotAct")}
        </label>
      </Layout.Footer>
    </AuraLayout>
  );
});
